import { defineStore } from "pinia";
import { useAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationOwnOffer = defineStore("curation-setting-own-offer-field", () => {
  const field = useAdditionalServiceField({
    id: "own_offer",
    functionalGroupCode: "OWN_OFFER",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("own_offer_classification");

  const isRequired = true;

  return { ...field, isRequired, hasUnpublishedChange };
});
